import { CheckboxInput } from '@adornis/formfield/fields/checkbox-input.js';
import type { FunctionalForm } from '@adornis/forms/use-form.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import type { JobTicketFormData } from '../../../db/utils/jobTicketValidator.js';

/** All three have to be confirmed before a ticket can be ordered. */
export const JobTicketConsentFields = stateful((props: { form: FunctionalForm<JobTicketFormData> }) => {
  return html`
    <div class="flex flex-col gap-2">
      ${CheckboxInput({
        ...props.form.field('jobTicketKenntnis'),
        label:
          'Ich habe zur Kenntnis genommen, dass das Job-Ticket gekündigt wurde, falls ich ein Job-Ticket vom Bistum Mainz hatte.',
      })}
      ${CheckboxInput({
        ...props.form.field('jobTicketBestaetigt'),
        label:
          'Ich will ein Job-Ticket mit den Bedingungen des Tickets, die von denen des Job-Tickets abweichen. ' +
          'Das Ticket kostet 63 € pro Monat. Der Arbeitgeberzuschuss beträgt 18,90 €. ' +
          'Mein monatlicher Anteil ist daher 44,10 €, der von meinen monatlichen Bezügen einbehalten wird.',
      })}
      ${CheckboxInput({
        ...props.form.field('jobTicketDatenweitergabe'),
        label: 'Ich stimme der Datenweitergabe der oben genannten Daten an das Verkehrsunternehmen zu.',
      })}
    </div>
  `;
});
